<template>
  <v-container :style="rowWidth" class="px-0">
    <div class="background-color-white mb-3 mb-sm-6 mr-sm-0 rounded-lg">
      <div
        class="background-color-white pb-3 fixed-header"
        :class="{ 'top-90': rewardsFormat }"
      >
        <v-row class="pl-5 pt-3">
          <v-col cols="1">
            <Icon
              :name="'crownrewards'"
              :color="$vuetify.theme.themes.light.secondary"
              :title="'crownrewards'"
              :style="{ height: '24px', width: '24px' }"
            ></Icon>
          </v-col>
          <v-col cols="5" class="pl-0">
            <span class="Rewards text-decoration-underline">Rewards</span>
          </v-col>
        </v-row>

        <!-- TODO add NavigationSwiper AFTER TIMOFEY PUSHES REFACTORED CODE -->
        <v-row class="mt-0 pl-7">
          <v-col cols="4" class="px-0 mr-1">
            <v-btn
              depressed
              :color="
                activeBtn == 'points' ? 'var(--v-secondary-base)' : '#e4e4e4'
              "
              @click="toggle('points')"
              :height="25"
              :class="activeBtn == 'points' ? 'white--text' : '#e4e4e4'"
              class="toggle-btn"
            >
              Store Points
            </v-btn>
          </v-col>
          <v-col class="pl-0">
            <v-btn
              depressed
              :color="activeBtn == 'clubs' ? 'var(--v-secondary-base)' : ''"
              @click="toggle('clubs')"
              :height="25"
              :class="activeBtn == 'clubs' ? 'white--text' : ''"
              class="toggle-btn"
            >
              Store Clubs
            </v-btn>
          </v-col>
        </v-row>
      </div>
      <XsPoints ref="points" class="mt-16" style="scroll-margin-top: 300px" />
      <XsClubs ref="clubs" style="scroll-margin-top: 265px" />
    </div>
  </v-container>
</template>

<script>
import XsClubs from "./Clubs.vue";
import XsPoints from "./Points.vue";
import Icon from "@/components/UI/Icon.vue";
import { mapGetters } from "vuex";

export default {
  name: "XsRewards",
  components: {
    XsPoints,
    XsClubs,
    Icon,
  },
  computed: {
    rowWidth() {
      return "width: 100vw";
    },
    ...mapGetters("store", { rewardsFormat: "rewardsFormat" }),
  },
  data() {
    return {
      activeBtn: "points",
    };
  },
  mounted() {
    // Initialize the Intersection Observer when the component is mounted
    this.initIntersectionObserver();
  },
  methods: {
    initIntersectionObserver() {
      // Create a new Intersection Observer
      const observer = new IntersectionObserver(this.handleIntersection, {
        root: null, // Use the viewport as the root
        threshold: 0.1, // Trigger when 10% of the element is in view
      });
      observer.observe(this.$refs.clubs.$el);
    },
    handleIntersection(entries) {
      // This function will be called whenever the element enters or exits the viewport
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.activeBtn = "clubs";
        } else {
          // The element is out of view
          this.activeBtn = "points";
        }
      });
    },
    toggle(btn) {
      this.activeBtn = btn;
      this.$refs[btn].$el.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    },
  },
};
</script>

<style scoped>
.btn-active {
  background-color: var(--v-secondary-base) !important;
  color: white !important;
}
.fixed-header {
  position: fixed;
  top: 185px;
  width: 100%;
  z-index: 1;
}
.Rewards {
  width: 78px;
  height: 23px;
  flex-grow: 0;
  margin: 0 0 0 6px;
  font-family: "Roboto", sans-serif;
  font-size: 20px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: var(--v-secondary-base);
}
.toggle-btn {
  font-weight: bold;
  font-size: 12px;
}
.top-90 {
  top: 90px !important;
}
</style>
